import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chartContainer", "metricsContainer", "funnelContainer"]

  connect() {
    // Set initial period data
    this.updatePeriod()
  }

  updatePeriod(event) {
    const selectedPeriod = event ? event.target.value : "30_days"

    // Update charts and metrics based on selected period
    this.updateLineChart(selectedPeriod)
    this.updateMetrics(selectedPeriod)
    this.updateFunnelData(selectedPeriod)
  }

  updateLineChart(period) {
    const chartContainer = document.querySelector('.chart-container')
    if (!chartContainer) return

    // Get mock data for the selected period
    const chartData = this.getChartData(period)

    // Update chart subtitle to show period
    const subtitle = document.querySelector('.chart-subtitle')
    if (subtitle) {
      subtitle.textContent = this.getPeriodLabel(period)
    }
  }

  updateMetrics(period) {
    // Update the key metrics based on period
    const metricsData = this.getMetricsData(period)

    // Update CTR
    const ctrElement = document.querySelector('.stats:contains("4.2%")')
    // Update Conversion Rate
    const conversionElement = document.querySelector('.stats:contains("6.0%")')
    // Update Session Duration
    const sessionElement = document.querySelector('.stats:contains("3m 45s")')
    // Update Bounce Rate
    const bounceElement = document.querySelector('.stats:contains("42%")')
  }

  updateFunnelData(period) {
    // Update funnel numbers based on period
    const funnelData = this.getFunnelData(period)

    // This would update the funnel display but since we have multiple
    // funnel containers for different sources, we'd need to update all of them
  }

  getChartData(period) {
    const datasets = {
      "7_days": {
        pageViews: {"Sep 16": 4200, "Sep 17": 4500, "Sep 18": 4800, "Sep 19": 5100, "Sep 20": 5400, "Sep 21": 5700, "Sep 22": 6000},
        uniqueVisitors: {"Sep 16": 3200, "Sep 17": 3400, "Sep 18": 3600, "Sep 19": 3800, "Sep 20": 4000, "Sep 21": 4200, "Sep 22": 4400}
      },
      "30_days": {
        // Current 30-day data (already in template)
      },
      "6_months": {
        pageViews: {"Apr": 65000, "May": 72000, "Jun": 85000, "Jul": 95000, "Aug": 110000, "Sep": 125000},
        uniqueVisitors: {"Apr": 42000, "May": 48000, "Jun": 56000, "Jul": 64000, "Aug": 75000, "Sep": 85000}
      },
      "1_year": {
        pageViews: {"Q4 2023": 180000, "Q1 2024": 220000, "Q2 2024": 280000, "Q3 2024": 350000},
        uniqueVisitors: {"Q4 2023": 125000, "Q1 2024": 155000, "Q2 2024": 195000, "Q3 2024": 245000}
      }
    }

    return datasets[period] || datasets["30_days"]
  }

  getMetricsData(period) {
    const metrics = {
      "7_days": { ctr: "4.8%", conversion: "7.2%", discountUsage: "32%", bounce: "38%" },
      "30_days": { ctr: "4.2%", conversion: "6.0%", discountUsage: "28%", bounce: "42%" },
      "6_months": { ctr: "3.8%", conversion: "5.5%", discountUsage: "25%", bounce: "45%" },
      "1_year": { ctr: "3.5%", conversion: "5.2%", discountUsage: "22%", bounce: "47%" }
    }

    return metrics[period] || metrics["30_days"]
  }

  getFunnelData(period) {
    const funnels = {
      "7_days": {
        all: { visitors: 6000, clicks: 2880, checkouts: 432, purchases: 288 },
        qr_code: { visitors: 600, clicks: 480, checkouts: 120, purchases: 84 },
        emails: { visitors: 1500, clicks: 525, checkouts: 105, purchases: 75 }
      },
      "30_days": {
        all: { visitors: 25000, clicks: 10000, checkouts: 2000, purchases: 1500 },
        qr_code: { visitors: 2500, clicks: 2000, checkouts: 500, purchases: 375 },
        emails: { visitors: 6250, clicks: 2188, checkouts: 438, purchases: 313 }
      },
      "6_months": {
        all: { visitors: 450000, clicks: 171000, checkouts: 36000, purchases: 23400 },
        qr_code: { visitors: 45000, clicks: 36000, checkouts: 9000, purchases: 6750 },
        emails: { visitors: 112500, clicks: 39375, checkouts: 7875, purchases: 5625 }
      },
      "1_year": {
        all: { visitors: 1200000, clicks: 420000, checkouts: 84000, purchases: 52800 },
        qr_code: { visitors: 120000, clicks: 96000, checkouts: 24000, purchases: 18000 },
        emails: { visitors: 300000, clicks: 105000, checkouts: 21000, purchases: 15000 }
      }
    }

    return funnels[period] || funnels["30_days"]
  }

  getPeriodLabel(period) {
    const labels = {
      "7_days": "Last 7 days",
      "30_days": "Last 30 days",
      "6_months": "Last 6 months",
      "1_year": "Last 12 months"
    }

    return labels[period] || labels["30_days"]
  }
}